module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelBeneficiaries"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Beneficiary Information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.beneficiaries.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md': _vm.beneficiaries.length > 10,
        'table-responsive': true,
        'bottom-margin': true,
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.beneficiaries), function(beneficiary, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (beneficiary.beneficiaryName),
        expression: "beneficiary.beneficiaryName"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.hasNameError(beneficiary.id),
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (beneficiary.beneficiaryName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          beneficiary.beneficiaryName = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.hasNameError(beneficiary.id)) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v("\n                Beneficiary name is required\n              ")]) : _vm._e()] : [_vm._v("\n              " + _vm._s(beneficiary.beneficiaryName) + "\n            ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (beneficiary.percentage),
        expression: "beneficiary.percentage",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.hasError(beneficiary.id)
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (beneficiary.percentage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          beneficiary.percentage = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (_vm.hasError(beneficiary.id)) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v("\n                Total percentage cannot exceed 100% or be less than 0\n              ")]) : _vm._e()] : [_vm._v(" " + _vm._s(beneficiary.percentage) + "% ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.isLoading || _vm.hasError(beneficiary.id)
      },
      on: {
        "click": function($event) {
          _vm.saveBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-save fa-2x"
    })])] : [_c('button', {
      staticClass: "btn btn-edit",
      attrs: {
        "type": "button",
        "aria-label": "Edit beneficiary"
      },
      on: {
        "click": function($event) {
          _vm.editBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-edit fa-2x"
    })])], _vm._v(" "), _c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button",
        "disabled": _vm.isLoading,
        "aria-label": "Delete beneficiary"
      },
      on: {
        "click": function($event) {
          _vm.deleteBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x"
    })])], 2)])
  }))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-add-beneficiary",
    attrs: {
      "disabled": _vm.beneficiaries.length >= 10
    },
    on: {
      "click": _vm.addNewBeneficiary
    }
  }, [_vm._v("\n    Add new beneficiary\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No beneficiaries found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26db51f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountBeneficiaries.vue
// module id = 2123
// module chunks = 1